
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 4a8 8 0 103.555 15.169 1 1 0 11.89 1.791A9.963 9.963 0 0112 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10v1c0 1.409-.353 2.535-1.013 3.328A3.199 3.199 0 0118.5 17.5a3.564 3.564 0 01-3.09-1.843A5 5 0 1115 8a1 1 0 012 0v6c0 .884.736 1.5 1.5 1.5a1.2 1.2 0 00.95-.453c.278-.332.55-.956.55-2.047v-1a8 8 0 00-8-8zm3 8a3 3 0 10-6 0 3 3 0 006 0z"}})])
          )
        }
      }
    